import { Modal } from "../../../../components/Modal";
import React, { useEffect, useState } from "react";
import { Form, Input, Radio, Skeleton, Space } from "antd";
import { createNotification } from "../../../../components";
import { getRoles, sendInvite } from "../../../../services/account/api";
import { FormattedMessage, useIntl } from "react-intl";

export default function NewInviteModal({ open, onCancel, onSubmit }) {
  const intl = useIntl();
  const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSubmiting, setSubmit] = useState(false);
  const [submittable, setSubmittable] = useState(false);

  const [role, setRole] = useState();
  const [email, setEmail] = useState("");

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);


  useEffect(() => {
    getRoles()
      .then(setOptions)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onChange = (e) => {
    setRole(e.target.value);
  };

  const submitInvite = async () => {
    setSubmit(true);
    await sendInvite({ email, role_id: role })
      .then(() => {
        createNotification(
          "success",
          intl.formatMessage({
            id: "page.invite.sent.notification",
          }),
        );
        onSubmit();
      })
      .catch((err) => {
        if (err.response && err.response.data.code === "existing_email") {
          createNotification(
            "error",
            intl.formatMessage({
              id: "page.invite.existing_email.notification",
            }),
          );
        } else {
          createNotification(
            "error",
            intl.formatMessage({
              id: "page.invite.failed.notification",
            }),
          );
        }
      })
      .finally(() => {
        setSubmit(false);
      });
  };

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={<FormattedMessage id="page.invite.modal.title" />}
      />
      <Modal.Content align={"start"}>
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: 'flex',
          }}
        >
          <h1 className="text-2xl text-black">
            <FormattedMessage id="page.invite.modal.subtitle" />
          </h1>
          <p className="text-sm text-gray-500">
            <FormattedMessage id="page.invite.modal.description" />
          </p>

          <Form layout="vertical" form={form}>
            <Form.Item 
              label="E-mail"
              required
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please input the email!',
                },
                { max: 45 }
              ]}
            >
              <Input
                required
                size="large"
                name="email"
                placeholder="example@mail.com"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label={intl.formatMessage({ id: "page.invite.modal.role" })}
              required
              name="role"
              rules={[
                {
                  required: true,
                  message: 'Please select a profile!',
                },
              ]}
            >
              {isLoading ? (
                <div className="gap-y-2 grid">
                  <Skeleton.Input active size={"small"} block />
                  <Skeleton.Input active size={"small"} block />
                </div>
              ) : (
                <Radio.Group required onChange={onChange} value={role}>
                  <Space direction="vertical">
                    {options.map((option) => {
                      return (
                        <Radio className="text-gray-500" value={option.name} key={option.name}>
                          <FormattedMessage id={option.name} />
                        </Radio>
                      );
                    })}
                  </Space>
                </Radio.Group>
              )}
            </Form.Item>
          </Form>
        </Space>
      </Modal.Content>
      <Modal.Actions
        loading={isSubmiting}
        disabled={!submittable}
        submitText={<FormattedMessage id={"send"} />}
        onSubmitAction={submitInvite}
        onCancelAction={onCancel}
      />
    </Modal.Root>
  );
}
